import { fromJS, List, Map } from 'immutable';

/* * * * * * * * * FilterApp Reducer * * * * * * * * */
let initialState = Map({
  "filterFields": Map(),
  "filters": Map(),
  "activeFilters": List(),
  "parameters": Map(),
  "parameter": '',
  "selectedParameter": 0,
  "chosenUnit": 'ug/L', // for single select discrete
  "chosenMatrix": "Groundwater" // for single select discrete
});

/* * * * * * * * * Get Depth Slider Values Function * * * * * * * * */
/*const getDepthExtent = (state, activeMatrix, action) => {
  var allDataForMatrix,
      minDepth,
      maxDepth;
  allDataForMatrix = activeMatrix ? fromJS(action.data.data).filter(x => x.get('matrix') === activeMatrix) : fromJS(action.data.data);
  minDepth = allDataForMatrix.map(x => +x.get('end_depth')).min();
  maxDepth = allDataForMatrix.map(x => +x.get('end_depth')).max();
  return [minDepth, maxDepth]
}

/* * * * * * * * * Create Initial Filters from Data * * * * * * * * */
/*const setFilters = (state, action) => {
   // set our slider mins and maxes in filter fields 
  let defaultUnit = action.data.data[0].unit;
  let defaultMatrix = action.data.data[0].matrix;
  // to do - automate this so that all filterFields of type 'interval' can go through this function -- and we auto set all... single: true ones as well -- TODO
  let depthExtent = getDepthExtent(state, defaultMatrix, action);

  let filterFields = state.get('filterFields').map((field) =>{
    if(field.get('column') === "year") {
        return field.set('extent', List([state.get('yearMin'), state.get('yearMax')]))
          .set('value',List([state.get('yearMin'), state.get('yearMax')]))
          .set('brush',List())
    } else if(field.get('column') === "end_depth") {
        return field.set('extent',List([depthExtent[0], depthExtent[1]]))
          .set('value',List([depthExtent[0], depthExtent[1]]))
          .set('brush',List())
    } else {
      return field
    }
  })
  
  let filterList = [];
  var i = 0;
  filterFields.forEach( (field) => {
    switch(field.get('type')){
      case "discrete":
      var grouped = fromJS(action.data.data).groupBy( (value) =>{
           return value.get(field.get('column'));
        }).keySeq().sort().map( (value) => {
          return Map({"filter": value, "field": field.get('column'), "active":false, "id": i, "field_id": field.get('id'),"type":field.get('type'),"single":field.get('single'), "visible": true})
        });
        grouped.forEach( (value) => {
          i++
          filterList.push(value);
        })
      break
      case "interval":
          filterList.push(Map({"filter":field.get('value'), "field":field.get('column'), "active":false, "id":i, "field_id": field.get('id'),"type":field.get('type'),"single":field.get('single'),"visible":false}));
          i++;
      break
      default:
    };
  });

  // if they are type 'single' : true set first field's 'active' to true.  --- not abstracted to auto-code or database yet....
  var newFilterList = List();
  filterList = List(filterList);
  newFilterList = filterList.map(filter =>
    {
      if(filterList.filter(item => item.get('field') === filter.get('field')).size < 2) {
        return filter.update(
          'visible',
          visible => false
        )
      } else {
        return filter;
      }
    }
  ).update(filterList.findIndex(item => item.get('field') === 'matrix' && item.get('filter') === defaultMatrix), item => item.set('active', true)
  ).update(filterList.findIndex(item => item.get('field') === 'unit' && item.get('filter') === defaultUnit), item => item.set('active', true));

  let fieldsToExpand = newFilterList.filter(row => row.get('active')).map(row => row.get('field'))
  let newFilterFields = filterFields.map(row => row.set('visible', fieldsToExpand.includes(row.get('column'))).set('activeFilters',fieldsToExpand.includes(row.get('column'))))

  return state.set('filters', newFilterList).set('filterFields', newFilterFields);
}*/

/* * * * * * * * * Set Active Filter Fields * * * * * * * * */
const setActiveFields = (state, action) => {
  let newFilterFields = state.get('filterFields').map(row =>
    row.set('activeFilters', state.get('activeFilters').has(row.get('column')))
  )
  return state.set('filterFields', newFilterFields)
}

/* * * * * * * * * Set Active Filters Function * * * * * * * * */
const setActiveFilters = (state, action) => {
  var newActiveFilters = state.get('filters').filter((value) => {
        return value.get('active') === true;
      }).groupBy( (value) => {
        return value.get('field');
      }).map( (value) => {
        let type = state.get('filterFields').get(value.get(0).get('field_id')).get('type');
        return Map({'filters' : value.map( (row) => row.get('filter')), 'type' : type});
      });
  var newState = state.set('activeFilters', newActiveFilters);
  return newState;
}

/* * * * * * * * * Get Parameters and Parameter Types * * * * * * * * */
/*export const getParameters = (state, action) => {
  let parameters = state.get('parameters').map((row) => {
    return Map({'label': row.get('parameter'),'value': row.get('parameter'), 'type': row.get('parameter_type') });
  });
  return state.set('parameters', parameters);
}*/


const FilterApp = (state = initialState, action) => {

  var id, single, currentVal;
  var newState = Map();

  switch(action.type) {

    /* * * * * * * * * Basic Actions * * * * * * * * */
    case "RECEIVE_DATA":
      let newData = state.set('activeFilters', Map())

      //let stateWithFilters =  setFilters(newData, action)
      let stateWithActiveFilters = setActiveFilters(newData, action)
      let stateWithActiveFields = setActiveFields(stateWithActiveFilters, action)
      //let stateWithParameters = getParameters(stateWithActiveFields, action)
      return stateWithActiveFields;

    case "RECEIVE_FILTERS":
      return state.set('filterFields', fromJS(action.data.fields)).set('filters', fromJS(action.data.filters)).set('activeFilters', Map());

    /* * * * * * * * * FILTER ACTIONS * * * * * * * * */
    case "TOGGLE_FIELD":
      id = parseInt(action.id, 10);
      return state.setIn(['filterFields',id,'visible'], !state.get('filterFields').get(id).get('visible'));

    case "TOGGLE_FILTER":
      single = state.get('filters').get(action.id).get('single');
      var field = state.get('filters').get(action.id).get('field');
      if(!single) {
        newState = state.setIn(['filters',action.id,'active'], !state.get('filters').get(action.id).get('active'));
      } else {
        currentVal = state.get('filters').get(action.id).get('active');
        if(!currentVal) {  // if this toggle is turning it 'on', turn all others off and then turn it on
          newState = state.update(  // turn associated filters on, or else turn them off
          'filters',
          filters => filters.map(filter => {
            if(filter.get('id') === action.id) {
              return filter.update('active', active => true)
            } else if (filter.get('id') !== action.id && filter.get('field') === field) {
              return filter.update('active', active => false)
            } else {
              return filter;
            }
          }))
        } else {
          newState = state.setIn(['filters',action.id,'active'], !state.get('filters').get(action.id).get('active'));
        }
      }
      return setActiveFields(setActiveFilters(newState, action), action);

    case "UPDATE_SLIDER":
      newState = state.setIn(['filterFields',action.field_id, "value"], List(action.value))
        .setIn(['filterFields', action.field_id, "brush"], List(action.brush))
        .setIn(['filters', action.filter_id, "active"], action.active)
        .setIn(['filters', action.filter_id, "filter"], action.value);
      return setActiveFilters(newState, action);

    default:
      return state;
  }
}

export default FilterApp;



// WEBPACK FOOTER //
// ./src/reducers/filter.js